module.exports = __webpack_public_path__ + "img/recipe_demo.ee9b1833.png";